import * as React from "react";
import { SVGProps } from "react";
interface ArrowSvgProps extends SVGProps<SVGSVGElement> {
  type: "up" | "down";
}
const ArrowSvg: React.FC<ArrowSvgProps> = ({ type, ...props }) => (
  <>
    {type === "down" && (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <path
          stroke="#FF6A55"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m13 9-5 5-5-5"
        />
        <path stroke="#FF6A55" strokeLinecap="round" strokeWidth={2} d="M8 2v12" />
      </svg>
    )}
    {type === "up" && (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <path
          stroke="#53C854"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m3 7.5 5-5 5 5"
        />
        <path stroke="#53C854" strokeLinecap="round" strokeWidth={2} d="M8 14.5v-12" />
      </svg>
    )}
  </>
);
export default ArrowSvg;
